module.exports = __webpack_public_path__ + "static/img/semi-heavy-horse-yellow.11fc12e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/semi-heavy-horse-yellow.svg
// module id = NAUZ
// module chunks = 82